module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0061.jpg?v=4e05d878";